// extracted by mini-css-extract-plugin
export default {"wrap":"DriverOrder_wrap__lBeoY","tabs":"DriverOrder_tabs__9za39"};